<div class="value date">
  {{ format(date) }}
  <div>
    {{format(date, 'time') }}
  </div>
</div>
